import React from 'react'
import { Container, Skeleton } from '@mui/material'
import { FastabLogo } from 'assets/images'
import { useSelector } from 'react-redux'
import { restuarantData } from 'features/restaurant/restaurant'
import { tabData } from 'features/tab/tab'
import { IRestaurantDetailData } from 'interfaces/restaurant'
import { Link } from 'react-router-dom'
import './PageSkeleton.css'

interface PageSkeletonProps {
  withFooter?: boolean
}

const PageSkeleton: React.FC<PageSkeletonProps> = ({ withFooter = false }) => {
  const restaurantData: IRestaurantDetailData = useSelector(restuarantData)
  const tabDetailData = useSelector(tabData)

  return (
    <div className="page-skeleton">
      {/* Real Header - same as the app */}
      <header className="mui-fixed">
        <Container className="header" maxWidth="md">
          <Link
            to={restaurantData?.restaurantId ? '/main-menu' : '/home'}
            className="logo"
          >
            <img src={FastabLogo} alt="FasTab" className="fastab-guest-logo" />
          </Link>
          <div className="resturant-info">
            <p>
              {restaurantData?.restaurantName || (
                <Skeleton variant="text" width={180} height={20} />
              )}{' '}
              -{' '}
              {restaurantData?.establishmentName || (
                <Skeleton variant="text" width={120} height={16} />
              )}
            </p>
            <small>
              Table:{' '}
              {(tabDetailData?.tableName || sessionStorage.getItem('tn')) ===
              null
                ? tabDetailData?.tableName || sessionStorage.getItem('tn')
                : (
                    tabDetailData?.tableName || sessionStorage.getItem('tn')
                  )?.replace('_', ' ') || (
                    <Skeleton variant="text" width={80} height={14} />
                  )}
            </small>
          </div>
        </Container>
      </header>

      {/* Main Content Skeleton */}
      <section
        className={`wrapper skeleton-wrapper ${
          withFooter ? 'with-footer' : ''
        }`}
      >
        <Container maxWidth="md" />
      </section>

      {/* Footer Skeleton */}
      {withFooter && (
        <footer className="skeleton-footer">
          <Container maxWidth="md" />
        </footer>
      )}
    </div>
  )
}

export default PageSkeleton
